export const mapBoxConfig = {
    accessToken: "pk.eyJ1IjoiamVyd2FsbGFjZSIsImEiOiIxMjIzOTlmMjYzZGYxNjg5YTEwYWUyYzAwZDAwM2YzZiJ9.ixDFhSmn8fHkc6fExkobzA",
    style: "mapbox://styles/jerwallace/cjoq0tp9a59j72smw9mya5s58",
};

export const iotConfig = {
    region: "us-east-1",
    endpoint: 'wss://a3k1wmckzweko3-ats.iot.us-east-1.amazonaws.com/mqtt',
};